import React, { Component } from "react";
import { Form, Row, Col, Container, Card } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import * as compose from "lodash.flowright";
import gql from "graphql-tag";
import {
  GET_WHATSAPP_TAGS,
  CREATE_WHATSAPP_CONTACT
} from "../../utils/whatsappHelper";
import AssignTestModal from "./AssignTestModal";
import "./_admissionForms.scss";

const ADD_ENQUIRY_FORM_SUBMISSION = gql`
  mutation ($input: SubmitEnquiryFormInput!) {
    submitEnquiryForm(input: $input)
  }
`;

const ASSIGN_ADMISSION_TEST_AUTO = gql`
  mutation ($enquiry_form_master_id: Int!, $institute_id: Int!, $branch_id: String!, $inserted_by: Int) {
    assignAdmissionTestAuto(
      enquiry_form_master_id: $enquiry_form_master_id,
      institute_id: $institute_id,
      branch_id: $branch_id,
      inserted_by: $inserted_by
    ) {
      id
      username
      password
    }
  }
`;

class FillAdmissionFormPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // mandatory fields
      student_name: "",
      student_mobile: "",
      student_email: "",
      gender: "",
      dob: "",
      enquiry_course_id: "",
      courseOptions: [],

      // dynamic fields
      dynamicFields: [],
      dynamicFieldValues: {},

      // ui state
      loader: false,
      errors: {},
      submitError: "",

      // after success
      showSuccess: false,
      newStudentId: null,

      // Assign test modal integration
      showAssignModal: false,
      autoAssigning: false,
      autoAssignError: "",

      // CRM Integration (WhatsApp)
      whatsAppTags: [],
      selectedTagId: "",
      isContactCreating: false,
      contactCreatedStatus: null, // 'success' | 'error' | null
    };
  }

  componentDidMount() {
    this.initFormFields();
    this.fetchWhatsAppTags();
  }

  fetchWhatsAppTags = async () => {
    const employeeId = parseInt(Cookies.get("id"));
    if (!employeeId) return;

    try {
      const result = await this.props.client.query({
        query: GET_WHATSAPP_TAGS,
        variables: { employee_id: employeeId },
        fetchPolicy: 'network-only'
      });

      if (result.data?.getWhatsAppTags?.success) {
        this.setState({ whatsAppTags: result.data.getWhatsAppTags.data || [] });
      }
    } catch (err) {
      console.error("Error fetching WhatsApp tags:", err);
    }
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.getEnquiryFormFields !== prevProps.getEnquiryFormFields &&
      !this.props.getEnquiryFormFields.loading
    ) {
      this.initFormFields();
    }
  }

  initFormFields = () => {
    const fields =
      this.props.getEnquiryFormFields &&
      this.props.getEnquiryFormFields.getEnquiryFormFields
        ? this.props.getEnquiryFormFields.getEnquiryFormFields
        : [];

    if (fields.length > 0) {
      console.log("API Form Fields Response:", fields);

      // filter out mandatory fields and standard hardcoded basic info
      const standardLabels = [
        "name",
        "mobile",
        "mobile number",
        "email",
        "date of birth",
        "dob",
        "gender",
        "sex",
      ];

      const dynamic = fields.filter((f) => {
        const label = (f.field_name || "").toLowerCase();
        
        if (label === "course name") {
          this.setState({ courseOptions: f.options || [] });
          return false;
        }

        const isBasic =
          f.id === 1 || f.id === 2 || f.id === -6 || standardLabels.includes(label);
        return f.order_no > 0 && !isBasic;
      });

      this.setState({ dynamicFields: dynamic });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    let filteredValue = value;

    // Name field: Accept only letters, spaces, and hyphens
    if (name === "student_name") {
      filteredValue = value.replace(/[^a-zA-Z\s\-']/g, "");
    }

    // Mobile field: Accept only digits
    if (name === "student_mobile") {
      filteredValue = value.replace(/[^0-9]/g, "");
    }

    this.setState({
      [name]: filteredValue,
      errors: { ...this.state.errors, [name]: "" },
    });
  };

  handleDynamicChange = (fieldId, value) => {
    const field = this.state.dynamicFields.find((f) => f.id === fieldId);
    let filteredValue = value;

    if (field) {
      const fieldType = (field.field_type || "").toLowerCase();

      // Number field: Accept only digits and decimal point
      if (fieldType === "number") {
        filteredValue = value.replace(/[^0-9.]/g, "");
        // Prevent multiple decimal points
        if ((filteredValue.match(/\./g) || []).length > 1) {
          filteredValue = filteredValue.replace(/\.(?=.*\.)/, "");
        }
      }

      // Email field: Basic filtering (handled by type="email" browser validation)
      if (fieldType === "email") {
        filteredValue = value;
      }

      // Date field: No special filtering needed (browser handles via type="date")
      if (fieldType === "date") {
        filteredValue = value;
      }

      // Text field: Accept only letters and spaces
      if (fieldType === "text") {
        const fieldNameLower = (field.field_name || "").toLowerCase();
        // If it's a name-like field, restrict to letters and spaces
        if (
          fieldNameLower.includes("name") ||
          (fieldNameLower.includes("student") &&
            fieldNameLower.includes("name"))
        ) {
          filteredValue = value.replace(/[^a-zA-Z\s\-']/g, "");
        }
      }

      // Textarea: Allow all characters
      if (fieldType === "textarea") {
        filteredValue = value;
      }
    }

    this.setState((prev) => ({
      dynamicFieldValues: {
        ...prev.dynamicFieldValues,
        [fieldId]: filteredValue,
      },
      errors: { ...prev.errors, [`field_${fieldId}`]: "" },
    }));
  };

  validate = () => {
    const {
      student_name,
      student_mobile,
      student_email,
      gender,
      dob,
      dynamicFields,
      dynamicFieldValues,
    } = this.state;
    const errors = {};

    if (!student_name.trim()) errors.student_name = "Name is required";

    if (!student_mobile.trim()) errors.student_mobile = "Mobile is required";
    else if (!/^\d{10}$/.test(student_mobile.trim()))
      errors.student_mobile = "Enter valid 10 digit mobile";

    if (!dob) errors.dob = "Date of birth is required";

    if (!this.state.enquiry_course_id) errors.enquiry_course_id = "Course Name is required";

    if (!gender) errors.gender = "Gender is required";

    if (!student_email.trim()) errors.student_email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(student_email.trim()))
      errors.student_email = "Enter a valid email address";

    // validate required dynamic fields with field-type-specific validation
    dynamicFields.forEach((field) => {
      const value = dynamicFieldValues[field.id];
      const fieldType = (field.field_type || "").toLowerCase();

      // Check if required
      if (field.is_required && !value) {
        errors[`field_${field.id}`] = `${field.field_name} is required`;
        return;
      }

      if (value) {
        // Validate field type
        if (fieldType === "number") {
          if (isNaN(parseFloat(value))) {
            errors[`field_${field.id}`] =
              `${field.field_name} must be a valid number`;
          }
        } else if (fieldType === "email") {
          if (!/\S+@\S+\.\S+/.test(value)) {
            errors[`field_${field.id}`] =
              `${field.field_name} must be a valid email`;
          }
        } else if (fieldType === "date") {
          if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            errors[`field_${field.id}`] =
              `${field.field_name} must be a valid date`;
          }
        }
      }
    });

    if (!this.state.selectedTagId) errors.selectedTagId = "Please select a tag";

    return errors;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const {
      student_name,
      student_mobile,
      student_email,
      gender,
      dob,
      dynamicFields,
      dynamicFieldValues,
    } = this.state;

    const { formId, stateData } = this.props;
    const branch_id = parseInt(stateData.branch_id);
    const institute_id = parseInt(Cookies.get("institutionid"));
    const userId = Cookies.get("user_id") || Cookies.get("id");
    const inserted_by = userId ? parseInt(userId) : 0;

    const remainingFormData = dynamicFields.map((field) => ({
      enquiry_field_id: field.id,
      value: dynamicFieldValues[field.id] || "",
    }));

    const selectedCourseId = parseInt(this.state.enquiry_course_id) || 0;

    this.setState({ loader: true, submitError: "" });

    try {
      const result = await this.props.client.mutate({
        mutation: ADD_ENQUIRY_FORM_SUBMISSION,
        variables: {
          input: {
            enquiry_form_id: parseInt(formId),
            institute_id,
            branch_id: branch_id,
            student_name: student_name.trim(),
            student_mobile: student_mobile.trim(),
            student_email: student_email.trim(),
            gender,
            dob,
            enquiry_course_id: selectedCourseId,
            inserted_by,
            remainingFormData,
          },
        },
      });

      // submitEnquiryForm returns the new enquiry_form_master id
      const newStudentId = result.data.submitEnquiryForm;

      this.setState({
        loader: false,
        showSuccess: true,
        newStudentId,
      });

      // Trigger WhatsApp Contact Creation in background
      this.createCRMContact(student_name, student_mobile, student_email, branch_id);

    } catch (err) {
      this.setState({
        loader: false,
        submitError: err.message.replace("GraphQL error: ", ""),
      });
    }
  };
  createCRMContact = async (name, mobile, email, branch_id) => {
    const employeeId = parseInt(Cookies.get("user_id") || Cookies.get("id"));
    const { selectedTagId } = this.state;
    
    if (!employeeId || !mobile) return;

    this.setState({ isContactCreating: true });
    try {
      const result = await this.props.client.mutate({
        mutation: CREATE_WHATSAPP_CONTACT,
        variables: {
          employee_id: employeeId,
          name: name.trim(),
          mobile: mobile.trim(),
          tag_id: selectedTagId || null,
          email: email ? email.trim() : null,
          branch_id: branch_id ? parseInt(branch_id, 10) : null
        }
      });

      if (result.data?.createWhatsAppContact?.success) {
        this.setState({ contactCreatedStatus: 'success' });
      } else {
        this.setState({ contactCreatedStatus: 'error' });
      }
    } catch (err) {
      console.error("CRM Contact creation failed:", err);
      this.setState({ contactCreatedStatus: 'error' });
    } finally {
      this.setState({ isContactCreating: false });
    }
  };

  handleAssignTest = () => {
    this.setState({ showAssignModal: true });
  };

  handleSkip = () => {
    this.handleCancel();
  };

  handleAssignModalClose = () => {
    this.handleCancel();
  };

  handleCancel = () => {
    this.props.history.push("/admission-forms");
  };

  renderDynamicField = (field) => {
    const { dynamicFieldValues, errors } = this.state;
    const value = dynamicFieldValues[field.id] || "";
    const errKey = `field_${field.id}`;
    let fieldType = (field.field_type || "").toLowerCase();

    // ── FORCED PATCH: Ensure Course Name is always a dropdown regardless of saved DB type
    const fieldNameLower = (field.field_name || "").toLowerCase();
    if (fieldNameLower.includes("course") || fieldNameLower.includes("course name")) {
        fieldType = "dropdown";
    }

    if (fieldType === "dropdown" || fieldType === "select") {
      let options = [];
      if (Array.isArray(field.options)) {
        options = field.options;
      } else if (typeof field.options === "string") {
        options = field.options.split(",").map((o) => o.trim()).filter((o) => o);
      }
      return (
        <Form.Group key={field.id} className="mb-4">
          <Form.Label className="af-field-label">
            {field.field_name} {field.is_required && <span className="text-danger">*</span>}
          </Form.Label>
          <Form.Control
            as="select"
            value={value}
            onChange={(e) => this.handleDynamicChange(field.id, e.target.value)}
            className={`form-control ${errors[errKey] ? "is-invalid" : ""}`}
          >
            <option value="">Select {field.field_name}</option>
            {options.map((opt, i) => (
              <option key={i} value={opt}>{opt}</option>
            ))}
          </Form.Control>
          {errors[errKey] && <small className="text-danger mt-1 d-block">{errors[errKey]}</small>}
        </Form.Group>
      );
    }

    if (fieldType === "radio") {
      let options = [];
      if (Array.isArray(field.options)) {
        options = field.options;
      } else if (typeof field.options === "string") {
        options = field.options.split(",").map((o) => o.trim()).filter((o) => o);
      }
      return (
        <Form.Group key={field.id} className="mb-4">
          <Form.Label className="af-field-label">
            {field.field_name} {field.is_required && <span className="text-danger">*</span>}
          </Form.Label>
          <div className="d-flex flex-row flex-wrap gap-4 mt-1">
            {options.map((opt, i) => (
              <label key={i} className="mb-0 custom-control custom-radio">
                <input
                  type="radio"
                  name={`dynamic_${field.id}`}
                  value={opt}
                  checked={value === opt}
                  onChange={() => this.handleDynamicChange(field.id, opt)}
                  className="custom-control-input"
                />
                <span className="custom-control-label" style={{ fontSize: "14px", fontWeight: "500", color: "#64748b", cursor: "pointer" }}>
                  {opt}
                </span>
              </label>
            ))}
          </div>
          {errors[errKey] && <small className="text-danger mt-2 d-block">{errors[errKey]}</small>}
        </Form.Group>
      );
    }

    const inputType =
      fieldType === "number"
        ? "number"
        : fieldType === "date"
          ? "date"
          : fieldType === "email"
            ? "email"
            : "text";

    // For textarea fields, render as textarea instead of input
    if (fieldType === "textarea") {
      return (
        <Form.Group key={field.id} className="mb-3">
          <Form.Label className="af-field-label">
            {field.field_name}
            {field.is_required && <span className="text-danger ml-1">*</span>}
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={value}
            onChange={(e) => this.handleDynamicChange(field.id, e.target.value)}
            placeholder={`Enter ${field.field_name}`}
            className={`form-control ${errors[errKey] ? "is-invalid" : ""}`}
            style={{ borderColor: errors[errKey] ? "#dc3545" : undefined }}
          />
          {errors[errKey] && (
            <small className="text-danger mt-1">{errors[errKey]}</small>
          )}
        </Form.Group>
      );
    }

    return (
      <Form.Group key={field.id} className="mb-4">
        <Form.Label className="af-field-label">
          {field.field_name} {field.is_required && <span className="text-danger">*</span>}
        </Form.Label>
        <Form.Control
          type={inputType}
          value={value}
          onChange={(e) => this.handleDynamicChange(field.id, e.target.value)}
          placeholder={`Enter ${field.field_name.toLowerCase()}`}
          className={`form-control ${errors[errKey] ? "is-invalid" : ""}`}
        />
        {errors[errKey] && <small className="text-danger mt-1 d-block">{errors[errKey]}</small>}
      </Form.Group>
    );
  };

  render() {
    const {
      student_name,
      student_mobile,
      student_email,
      gender,
      dob,
      dynamicFields,
      errors,
      loader,
      submitError,
      showSuccess,
      newStudentId,
      autoAssigning,
      autoAssignError,
      autoAssignCredentials,
    } = this.state;

    const { stateData } = this.props;
    const formName = stateData.form_name || "Admission Form";
    const instituteId = parseInt(Cookies.get("institutionid"));

    // If successfully submitted, render premium success state
    if (showSuccess) {
      const { branch_id } = stateData;
      const studentForModal = {
        id: newStudentId,
        student_name: student_name,
        student_mobile: student_mobile,
        branch_id: branch_id
      };

      return (
        <Container fluid className="px-3 pb-5 h-100 d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
          <Card className="af-premium-success-card shadow-lg border-0 w-100" style={{ maxWidth: '600px', borderRadius: '16px', overflow: 'hidden' }}>
            <div className="text-center py-5 bg-success text-white">
              <div className="af-success-icon-check mb-3">
                <i className="fas fa-check-circle fa-4x" />
              </div>
              <h2 className="font-weight-bold mb-0">Submission Successful!</h2>
              <p className="opacity-75 mb-0">High-five! {student_name} is now registered.</p>
            </div>
            
            <Card.Body className="p-4">
              {/* Data Summary */}
              <div className="af-success-data-summary p-3 rounded mb-4" style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                <Row className="mb-2">
                  <Col xs={5} className="text-muted small font-weight-bold">STUDENT NAME</Col>
                  <Col xs={7} className="text-dark font-weight-bold">{student_name}</Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5} className="text-muted small font-weight-bold">CONTACT NUMBER</Col>
                  <Col xs={7} className="text-dark">{student_mobile}</Col>
                </Row>
                <Row>
                  <Col xs={5} className="text-muted small font-weight-bold">CRM STATUS</Col>
                  <Col xs={7}>
                    {this.state.isContactCreating ? (
                      <span className="text-primary italic small">
                        <Spinner animation="border" size="sm" className="mr-1" style={{ width: '12px', height: '12px', borderWidth: '2px' }} /> 
                        Syncing to CRM...
                      </span>
                    ) : this.state.contactCreatedStatus === 'success' ? (
                      <span className="text-success small font-weight-bold">
                        <i className="fas fa-check-circle mr-1" /> Contact created in WhatsApp CRM
                      </span>
                    ) : this.state.contactCreatedStatus === 'error' ? (
                      <span className="text-danger small">
                        <i className="fas fa-exclamation-circle mr-1" /> CRM Sync Failed (Saved Locally)
                      </span>
                    ) : (
                      <span className="text-muted small">
                        <i className="fas fa-save mr-1 opacity-50" /> Admission saved locally
                      </span>
                    )}
                  </Col>
                </Row>
              </div>

              {/* Action Grid */}
              <div className="af-success-actions-grid d-flex flex-column gap-3">
                <Button 
                    variant="primary" 
                    className="af-premium-btn-v2 py-3"
                    onClick={this.handleAssignTest}
                >
                  <i className="fas fa-tasks mr-2" /> Assign Admission Test & Schedule
                </Button>

                <div className="d-flex flex-column flex-sm-row gap-3 mt-1">
                    <Button 
                        variant="outline-primary" 
                        className="w-100 py-2 mb-2 mb-sm-0"
                        onClick={() => this.props.history.push('/communications-center', { student_mobile })}
                    >
                        <i className="fab fa-whatsapp mr-2" /> Send Message
                    </Button>
                    <Button 
                        variant="light" 
                        className="w-100 py-2 text-muted"
                        onClick={this.handleCancel}
                    >
                        Return to Forms
                    </Button>
                </div>
              </div>
            </Card.Body>
          </Card>

          <AssignTestModal
            show={this.state.showAssignModal}
            onHide={() => this.setState({ showAssignModal: false })}
            student={studentForModal}
          />
        </Container>
      );
    }

    return (
      <Container fluid className="px-0 pb-5">
        <div className="af-fill-form-container">
          {/* ── Breadcrumb Navigation ── */}
          <ul className="af-breadcrumb mt-4">
            <li className="af-bc-item">
              <a href="#/admissions-dashboard" onClick={(e) => { e.preventDefault(); this.props.history.push("/admissions-dashboard"); }}>
                Admissions
              </a>
            </li>
            <li className="af-bc-item">
              <a href="#/admission-forms" onClick={(e) => { e.preventDefault(); this.props.history.push("/admission-forms"); }}>
                Forms
              </a>
            </li>
            <li className="af-bc-item active">{formName}</li>
          </ul>

          {/* ── Professional Header ── */}
          <div className="af-page-header-minimal">
            <h4 className="af-page-title">
              <i className="fas fa-file-signature" /> {formName}
            </h4>
            <p className="af-page-subtitle">
              Complete student registration by filling in the details below. All marked (*) fields are mandatory.
            </p>
          </div>

          <div className="d-flex flex-column gap-4">
            {/* Basic Information Section */}
            <div className="af-shadcn-card p-4 shadow-sm">
              {submitError && (
                <div className="alert alert-danger d-flex align-items-center mb-4" style={{ fontSize: "14px", borderRadius: "6px" }}>
                  <i className="fas fa-exclamation-circle mr-2" /> {submitError}
                </div>
              )}

              <div className="af-form-section-heading">
                <i className="fas fa-user-circle" /> Basic Information
              </div>

              <Row>
                <Col lg={6} md={6} sm={12}>
                  <Form.Group className="mb-4">
                    <Form.Label className="af-field-label">Student Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="student_name"
                      value={student_name}
                      onChange={this.handleChange}
                      placeholder="e.g. John Doe"
                      className={`form-control ${errors.student_name ? "is-invalid" : ""}`}
                    />
                    {errors.student_name && <small className="text-danger mt-1">{errors.student_name}</small>}
                  </Form.Group>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Group className="mb-4">
                    <Form.Label className="af-field-label">Mobile Number <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="tel"
                      name="student_mobile"
                      value={student_mobile}
                      onChange={this.handleChange}
                      placeholder="10 digit number"
                      maxLength={10}
                      className={`form-control ${errors.student_mobile ? "is-invalid" : ""}`}
                    />
                    {errors.student_mobile && <small className="text-danger mt-1">{errors.student_mobile}</small>}
                  </Form.Group>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Group className="mb-4">
                    <Form.Label className="af-field-label">Email Address <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="email"
                      name="student_email"
                      value={student_email}
                      onChange={this.handleChange}
                      placeholder="name@example.com"
                      className={`form-control ${errors.student_email ? "is-invalid" : ""}`}
                    />
                    {errors.student_email && <small className="text-danger mt-1">{errors.student_email}</small>}
                  </Form.Group>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Group className="mb-4">
                    <Form.Label className="af-field-label">Date of Birth <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="date"
                      name="dob"
                      value={dob}
                      onChange={this.handleChange}
                      className={`form-control ${errors.dob ? "is-invalid" : ""}`}
                    />
                    {errors.dob && <small className="text-danger mt-1">{errors.dob}</small>}
                  </Form.Group>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Form.Group className="mb-4">
                    <Form.Label className="af-field-label">Course Name <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="enquiry_course_id"
                      value={this.state.enquiry_course_id}
                      onChange={this.handleChange}
                      className={`form-control ${errors.enquiry_course_id ? "is-invalid" : ""}`}
                    >
                      <option value="">Select Course</option>
                      {this.state.courseOptions.map((course) => (
                        <option key={course.value} value={course.value}>
                          {course.label}
                        </option>
                      ))}
                    </Form.Control>
                    {errors.enquiry_course_id && <small className="text-danger mt-1">{errors.enquiry_course_id}</small>}
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-2">
                    <Form.Label className="af-field-label">Gender <span className="text-danger">*</span></Form.Label>
                    <div className="af-gender-selector mt-1">
                      {[
                        { value: "Male", icon: "fas fa-mars" },
                        { value: "Female", icon: "fas fa-venus" },
                        { value: "Others", icon: "fas fa-genderless" },
                      ].map((g) => (
                        <label key={g.value} className="af-gender-option">
                          <input
                            type="radio"
                            name="gender"
                            value={g.value}
                            checked={gender === g.value}
                            onChange={this.handleChange}
                          />
                          <span className="af-gender-pill">
                            <i className={g.icon} />
                            {g.value}
                          </span>
                        </label>
                      ))}
                    </div>
                    {errors.gender && <small className="text-danger mt-2 d-block">{errors.gender}</small>}
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Additional Information Section */}
            {dynamicFields.length > 0 && (
              <div className="af-shadcn-card p-4 shadow-sm">
                <div className="af-form-section-heading">
                  <i className="fas fa-list-ul" /> Additional Details
                </div>
                <Row>
                  {dynamicFields.map((field) => (
                    <Col lg={6} md={6} sm={12} key={field.id}>
                      {this.renderDynamicField(field)}
                    </Col>
                  ))}
                </Row>
              </div>
            )}

            {/* Tag Selection Section */}
            <div className="af-shadcn-card p-4 shadow-sm">
              <div className="af-form-section-heading">
                <i className="fas fa-tags" /> Tag Selection
              </div>
              <Row>
                <Col lg={6} md={12}>
                  <Form.Group className="mb-0">
                    <Form.Label className="af-field-label">Admission Category / Tag <span className="text-danger">*</span></Form.Label>
                    <Form.Control 
                        as="select"
                        value={this.state.selectedTagId}
                        onChange={(e) => this.setState({ selectedTagId: e.target.value, errors: { ...this.state.errors, selectedTagId: "" } })}
                        className={`form-control ${errors.selectedTagId ? "is-invalid" : ""}`}
                    >
                      <option value="">-- Select Tag --</option>
                      {this.state.whatsAppTags.map(tag => (
                        <option key={tag.id} value={tag.id}>{tag.tag_name}</option>
                      ))}
                    </Form.Control>
                    {errors.selectedTagId && <small className="text-danger mt-1 d-block">{errors.selectedTagId}</small>}
                    <small className="text-muted mt-2 d-block italic">
                      Please select a category to organize this student and enable follow-up communications.
                    </small>
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Form Actions */}
            <div className="d-flex flex-column flex-sm-row justify-content-end gap-3 pt-3">
              <button
                type="button"
                className="af-cancel-btn mr-md-3"
                onClick={this.handleCancel}
                disabled={loader}
                style={{ minWidth: "120px" }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="af-save-btn"
                onClick={this.handleSubmit}
                disabled={loader}
                style={{ minWidth: "160px" }}
              >
                {loader ? (
                  <><span className="spinner-border spinner-border-sm mr-2" /> Saving...</>
                ) : (
                  <><i className="fas fa-check-circle mr-2" /> Complete Submission</>
                )}
              </button>
            </div>
          </div>
        </div>

      </Container>
    );
  }
}

export default compose(
  withRouter,
  withApollo
)(FillAdmissionFormPage);
